import {GPTypeStructure} from "./gp-typestructure";

export class GPTypeCustomStructure extends GPTypeStructure {
    constructor(gst) {
        super(gst);

        this.typeName = "GPTypeCustomStructure"
        this.id = parseInt(gst["id"]);
        this.name = gst["name"] ? gst["name"] : "";
        this.type = "custom";
        this.temp = false;
        this.format = gst["type"] ? gst["type"] : "png"
        this.active = true;
        this.enabled = true;
    }

    staticGetPathForImage () {
        return GPSettings.customObjectGetPathForImage(this);
    }

    staticGetPathForThumb () {
        return GPSettings.customObjectGetPathForThumb(this);
    }
}